/// FOURJS_START_COPYRIGHT(D,2015)
/// Property of Four Js*
/// (c) Copyright Four Js 2015, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";
modulum("VMApplicationInfo", function (context, cls) {
  /**
   * Stores application general information like VM dialog configuration and parameters.
   * @class VMApplicationInfo
   * @memberOf classes
   */
  cls.VMApplicationInfo = function (info) /** @lends classes.VMApplicationInfo.prototype */ {
    /**
     * Application VM dialog mode : 'ua' or 'direct'
     * @type {?string}
     */
    this.mode = "ua";
    /**
     * Application identifier
     * @type {?string}
     */
    this.appId = null;
    /**
     * First front-end identifier (VM dialog)
     * @type {?string}
     */
    this.frontEndId1 = null;
    /**
     * Second front-end identifier (VM dialog)
     * @type {?string}
     */
    this.frontEndId2 = null;
    /**
     * Default time to ping VM (ms)
     * @type {number}
     */
    this.pingTimeout = 1000;
    /**
     * VM connection info
     * @type {Object}
     */
    this.connectionInfo = null;
    /**
     * Session identifier in UA dialog
     * @type {?string}
     */
    this.session = null;
    /**
     * Page number in UA dialog
     * @type {number}
     */
    this.page = 1;
    /**
     * Aui dialog om order increment
     * @type {number}
     */
    this.auiOrder = 0;
    /**
     * Default relative path to Web components
     * @type {?string}
     */
    this.webComponent = null;
    /**
     * User defined relative path to Web components
     * @type {?string}
     */
    this.webComponentUsrPath = null;
    /**
     * If style browserMultiPage is activated ; helps to know where to open the new application
     * @type {boolean}
     */
    this.inNewWindow = false;
    /**
     * Native resource path prefix
     * @type {?string}
     */
    this.nativeResourcePrefix = null;

    const keys = Object.keys(info);
    for (const element of keys) {
      this[element] = info[element];
    }
    this.ending = null;
  };
});
